import React, { useState } from 'react';
import { Modal, Button, Form, Card, ListGroup } from 'react-bootstrap';
import { FaCalendarAlt, FaClock, FaUser } from 'react-icons/fa';

const styles = {
  modalHeader: {
    backgroundColor: '#0B1F4B',
    color: 'white',
  },
  modalBody: {
    backgroundColor: '#0B1F4B',
    color: 'white',
    height: 'calc(100vh - 56px)',
    overflowY: 'auto',
  },
  modalFooter: {
    backgroundColor: '#0B1F4B',
  },
  card: {
    backgroundColor: '#17296B',
    color: 'white',
    marginBottom: '10px',
  },
  listItem: {
    backgroundColor: '#0B1F4B',
    color: 'white',
    marginBottom: '5px',
  },
  formControl: {
    marginBottom: '10px',
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  timeInputs: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
  },
};

const AddShiftModal = ({ show, handleClose }) => {
  const [view, setView] = useState('savedShifts');

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="custom-modal-right"
      backdrop={false}
    >
      <Modal.Header closeButton style={styles.modalHeader}>
        <Modal.Title>Adicionar Turnos</Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        <div style={styles.flexContainer}>
          <Button
            variant={view === 'savedShifts' ? 'primary' : 'outline-primary'}
            onClick={() => setView('savedShifts')}
            style={{ flex: 1, marginRight: '5px' }}
          >
            Turnos guardados
          </Button>
          <Button
            variant={view === 'newShift' ? 'primary' : 'outline-primary'}
            onClick={() => setView('newShift')}
            style={{ flex: 1 }}
          >
            Turnos a partir do zero
          </Button>
        </div>

        {view === 'savedShifts' && (
          <div>
            <Card style={styles.card}>
              <Card.Body>
                <FaUser /> Duarte Rocha
                <br />
                <FaCalendarAlt /> Seg, 3 de março 2025
              </Card.Body>
            </Card>
            <Form.Control type="text" placeholder="Pesquisa por título" style={styles.formControl} />
            <ListGroup>
              <ListGroup.Item style={styles.listItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    <FaClock /> noite abertura 1
                  </span>
                  <span>18:00 - 01:00 +1d</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={styles.listItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    <FaClock /> noite fecho 1
                  </span>
                  <span>00:30 - 06:30</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={styles.listItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    <FaClock /> Turno do Dia 1
                  </span>
                  <span>08:00 - 17:00</span>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </div>
        )}

        {view === 'newShift' && (
          <div>
            <Card style={styles.card}>
              <Card.Body>
                <FaUser /> Duarte Rocha
                <br />
                <FaCalendarAlt /> Seg, 3 de março 2025
              </Card.Body>
            </Card>
            <Form.Group>
              <Form.Label>Nome do Turno</Form.Label>
              <Form.Control type="text" placeholder="Nome do Turno" style={styles.formControl} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Horário</Form.Label>
              <div style={styles.timeInputs}>
                <Form.Control type="time" />
                <Form.Control type="time" />
              </div>
            </Form.Group>
            <Button variant="outline-light" style={styles.formControl}>
              Adicionar Pausa
            </Button>
            <Form.Group>
              <Form.Label>Local</Form.Label>
              <Form.Control as="select" style={styles.formControl}>
                <option>Selecionar</option>
                <option>Local 1</option>
                <option>Local 2</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Nota</Form.Label>
              <Form.Control as="textarea" rows={3} placeholder="Adicione uma nota a este turno" style={styles.formControl} />
            </Form.Group>
            <Form.Check
              type="checkbox"
              label="Guardar este turno para atribuição futura"
              style={styles.formControl}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={styles.modalFooter}>
        <Button variant="outline-light" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary">Adicionar Turno</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddShiftModal;